import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
var backgroundColorStyles = function backgroundColorStyles(active, completed, error, theme) {
  if (active || completed) {
    return theme.palette.primary.main;
  }
  if (error) {
    return theme.palette.secondary.main;
  }
  return '#fff';
};
var borderStyles = function borderStyles(active, completed, error, theme) {
  if (active || completed) {
    return "1px solid " + theme.palette.primary.main;
  }
  if (!completed || error) {
    return "1px solid " + theme.palette.secondary.main;
  }
  return "1px solid " + theme.palette.grey[400];
};
var textColorStyles = function textColorStyles(active, completed, error, theme) {
  if (!active && !error && !completed) {
    return theme.palette.secondary.main;
  }
  return '#fff';
};
export var StyledContainer = styled('div')(function (_ref) {
  var active = _ref.active,
    completed = _ref.completed,
    error = _ref.error,
    isMobile = _ref.isMobile,
    theme = _ref.theme;
  return {
    borderRadius: 99,
    height: isMobile ? 32 : 50,
    width: isMobile ? 32 : 50,
    display: 'flex',
    zIndex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    backgroundColor: backgroundColorStyles(active, completed, error, theme),
    border: borderStyles(active, completed, error, theme),
    '& svg': {
      color: '#fff'
    }
  };
});
export var StyledText = styled(Typography)(function (_ref2) {
  var active = _ref2.active,
    completed = _ref2.completed,
    error = _ref2.error,
    isMobile = _ref2.isMobile,
    theme = _ref2.theme;
  return {
    fontSize: isMobile ? 16 : 22,
    fontWeight: 700,
    color: textColorStyles(active, completed, error, theme)
  };
});